import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { ValidationDashboardUrl } from './ValidationDashboardUrl';

const postVisualValidationComparison = (data: {
  dataObjectVersion1Id: number;
  dataObjectVersion2Id: number;
}) =>
  apiClient
    .post<{ externalCode: string }>(ValidationDashboardUrl.COMPARISON, data)
    .then((response) => response.data);

export const useGenerateVisualValidationComparisonMutation =
  createApiMutationHook(
    ['visualValidationComparison'],
    postVisualValidationComparison,
  );
